export default {
  back: 'Voltar às campanhas',
  title: 'Campanha',
  sent_at: 'Enviado {{time}}',
  breakdown_title: 'Resumo de entrega',
  pending_receipts: {
    title: 'As estatísticas de entrega estão a caminho',
    description:
      'Esta campanha foi enviada agora mesmo. Os fornecedores de push confirmam a entrega cerca de 15 minutos após o envio, pelo que os números abaixo serão preenchidos por volta das {{time}} — não é necessária qualquer ação.',
    countdown:
      'Apple e Google confirmam as receções em cerca de {{minutes}}m {{seconds}}s (por volta das {{time}}). As estatísticas serão atualizadas automaticamente.',
    ready: 'As receções devem ter chegado. Os números abaixo estão a atualizar agora.',
    soon: 'em breve',
  },
  recipients: {
    title: 'Destinatários',
    subtitle: 'Para quem esta campanha foi enviada e se chegou ao dispositivo.',
    filters: {
      all: 'Todos',
      delivered: 'Entregue',
      pending: 'A aguardar confirmação',
      failed: 'Não entregue',
    },
    columns: {
      recipient: 'Destinatário',
      status: 'Estado',
      reason: 'Motivo',
      clicked: 'Clicado',
      sent_at: 'Enviado em',
    },
    status: {
      delivered: 'Entregue',
      pending: 'A aguardar confirmação',
      failed: 'Não entregue',
    },
    reasons: {
      DeviceNotRegistered: 'Aplicação removida ou notificações desativadas (token expirado)',
      MessageRateExceeded: 'Temporariamente limitado pela Expo',
      MessageTooBig: 'Conteúdo da notificação demasiado grande',
      MismatchSenderId: 'Credenciais push incompatíveis',
      InvalidCredentials: 'Credenciais push inválidas',
      batch_failed: 'Falha no envio do lote',
      missing_ticket: 'Sem confirmação devolvida pela Expo',
      unknown: 'Erro de entrega desconhecido',
    },
  },
};
